var _path, _polygon, _polygon2, _rect, _path2, _polygon3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgGiftBags = function SvgGiftBags(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gift_bags ",
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m429.12,223.87c.03-.48,2.9-48.53-6.96-96.59-8.66-42.22-29.07-93.19-77.07-96.23-18.02-1.14-33.38,3.12-46.96,13.01-55.57,40.5-56.21,157.11-56.21,158.29l-19.13-.45c0-5.05.71-124.32,62.16-169.11,17.33-12.63,37.89-18.3,61.1-16.83,113.65,7.2,102.7,200.88,102.18,209.12l-19.11-1.21Z",
    fill: "#015e85"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "89.69 85.24 171.55 107.9 250.97 54.68 294.55 109.87 323.44 82.57 384.08 154.37 150.82 149.31 89.69 85.24",
    fill: "#f0592b"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "467.38 182.95 490.89 126.18 435.19 147.9 405.42 103.29 337.93 139.8 314.27 113.06 285.87 132.62 210.61 120.09 180.77 133.73 89.69 85.24 112.21 158.52 467.38 182.95",
    fill: "#f4abe0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72.32,
    y: 156.03,
    width: 415.64,
    height: 420.27,
    transform: "translate(23.69 -16.97) rotate(3.62)",
    fill: "#93b847"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m375.99,220.51c.03-.48,2.9-48.53-6.96-96.59-8.66-42.22-29.07-93.19-77.07-96.23-18.02-1.14-33.38,3.12-46.96,13.01-55.57,40.5-57.05,170.32-57.05,171.49l-19.13-.45c0-5.05,1.54-137.53,62.99-182.32,17.33-12.63,37.89-18.3,61.1-16.83,113.65,7.2,102.7,200.88,102.18,209.12l-19.11-1.21Z",
    fill: "#015e85"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "500.82 169.58 521.33 546.58 474.26 589.01 500.82 169.58",
    fill: "#16a99e"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGiftBags, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gift_bags.41032d8e.svg";
export { ForwardRef as ReactComponent };